module.exports = __webpack_public_path__ + "static/media/hoc.4e13cce5.svg";